import {Environment} from './state'
import AppState from '../../types/app-state'

export const environmentsLoadingSelector = (state: AppState): boolean =>
    state.environments.isFetching
export const environmentsSelector = (state: AppState): Environment[] =>
    state.environments.environments
